(() => {
  if (window.__vicsCollectionReady) return;
  window.__vicsCollectionReady = true;

  const layoutKey = (desktop) => `vics-collection-layout-${desktop ? 'desktop' : 'mobile'}`;
  const layoutMedia = window.matchMedia('(min-width: 700px)');
  const layouts = new Map();
  const readLayout = (desktop) => {
    let saved = layouts.get(layoutKey(desktop));
    try { saved ||= sessionStorage.getItem(layoutKey(desktop)); } catch (_) { /* Storage can be unavailable in private browsing. */ }
    return ['large', 'medium', 'compact'].includes(saved) ? saved : 'medium';
  };

  const syncLayout = (section) => {
    const desktop = layoutMedia.matches;
    const saved = readLayout(desktop);
    const grid = section.querySelector('[data-vics-collection-grid]');
    if (!grid) return;
    grid.dataset.layout = saved;
    section.querySelectorAll('[data-vics-layout]').forEach((button) => {
      const active = button.dataset.vicsLayout === saved;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };

  const filterState = (form) => new URLSearchParams(new FormData(form)).toString();

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-vics-filter-open]');
    if (openButton) {
      const section = openButton.closest('[data-vics-collection-page]');
      const dialog = section && section.querySelector('[data-vics-filter-dialog]');
      if (dialog && !dialog.open) {
        const form = dialog.querySelector('[data-vics-collection-form]');
        dialog.__vicsFilterState = form ? filterState(form) : '';
        dialog.showModal();
        openButton.setAttribute('aria-expanded', 'true');
        dialog.__vicsTrigger = openButton;
        document.documentElement.classList.add('vics-collection-lock');
        dialog.querySelector('[data-vics-filter-close]')?.focus();
      }
      return;
    }

    const closeButton = event.target.closest('[data-vics-filter-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-vics-filter-dialog]');
      dialog?.close();
      return;
    }

    const layoutButton = event.target.closest('[data-vics-layout]');
    if (layoutButton) {
      const section = layoutButton.closest('[data-vics-collection-page]');
      const desktop = layoutMedia.matches;
      layouts.set(layoutKey(desktop), layoutButton.dataset.vicsLayout);
      try { sessionStorage.setItem(layoutKey(desktop), layoutButton.dataset.vicsLayout); } catch (_) { /* Keep the in-memory selection. */ }
      syncLayout(section);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-vics-filter-dialog]')) {
      document.documentElement.classList.remove('vics-collection-lock');
      event.target.__vicsTrigger?.setAttribute('aria-expanded', 'false');
      event.target.__vicsTrigger?.focus();
      const form = event.target.querySelector('[data-vics-collection-form]');
      // Match the reference: closing by X, backdrop, or Escape applies changed filters.
      if (form && !form.__vicsSubmitting && filterState(form) !== event.target.__vicsFilterState) {
        form.requestSubmit();
      }
    }
  }, true);

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-vics-filter-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  document.addEventListener('change', (event) => {
    const tag = event.target.closest('input[name="vics_tag"]');
    if (tag) {
      // The same catalog tag can appear in more than one category.
      tag.form.querySelectorAll('input[name="vics_tag"]').forEach((input) => {
        if (input.value === tag.value) input.checked = tag.checked;
        input.closest('label')?.classList.toggle('is-active', input.checked);
      });
    }
    const sort = event.target.closest('[data-vics-sort]');
    if (sort) {
      sort.form?.requestSubmit();
      return;
    }

    const desktopForm = event.target.closest('[data-vics-filter-form="desktop"]');
    if (desktopForm && window.matchMedia('(min-width: 1000px)').matches) {
      window.clearTimeout(desktopForm.__vicsSubmitTimer);
      desktopForm.__vicsSubmitTimer = window.setTimeout(() => desktopForm.requestSubmit(), 140);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-vics-collection-form]');
    if (!form) return;
    event.preventDefault();
    if (form.__vicsSubmitting) return;
    form.__vicsSubmitting = true;
    const data = new FormData(form);
    const tags = [...new Set(data.getAll('vics_tag').filter(Boolean))];
    data.delete('vics_tag');
    data.delete('page');
    const destination = new URL(form.action, window.location.origin);
    if (tags.length) destination.pathname += `/${tags.map(encodeURIComponent).join('+')}`;
    destination.search = new URLSearchParams(data).toString();
    form.setAttribute('aria-busy', 'true');
    window.location.assign(destination.href);
  });

  const initialise = () => {
    document.querySelectorAll('[data-vics-collection-page]').forEach(syncLayout);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();

  layoutMedia.addEventListener('change', initialise);
  document.addEventListener('shopify:section:load', initialise);
})();
